const doc = [({"da":({"js":({"admin":({"photos":({"create_card":({"upload":"Upload"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;